import '@babel/polyfill';
import {name, version} from './upi/packageInfo';

console.log( `
.::::::::::.    .::::::::::::::::::::::::::::.
::::::::::::    ::::::::::::::::::::::::::::::
::::::::::::    ::::::::::::::::::::::::::::::
::::::::::::    ::::::::::::         :::::::::
::::::::::::    ::::::::::::         :::::::::
::::::::::::    ::::::::::::    .:::::::::::::
::::::::::::    ::::::::::::    ::::::::::::::
::::::::::::    ::::::::::::    '::::::::::::'
::::::::::::::::::::::::::::
::::::::::::::::::::::::::::    .::::::::::::.
::::::::::::::::::::::::::::    ::::::::::::::
'::::::::::::::::::::::::::'    '::::::::::::'

${name}@${version}
` );

import '@core/LoggingProvider';
import '@util/console';
import './upi/i18n';
import './upi/configuration';
import './upi/plugin-configuration';
import './upi/data-layer';
import './upi/forms';
import './upi/page-init';
